(function () {
    'use strict';

    angular
		.module('corporateRoleModule')
		.directive('corporateRole', directive);

    directive.$inject = ['boxTmplScope',
						 'boxTmplHtml',
						 'boxTmplLinkFn'];

    function directive(boxTmplScope,
					   boxTmplHtml,
					   boxTmplLinkFn) {
        var directiveScope = _.clone(boxTmplScope);
        directiveScope.highlight = '=';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$rootScope', '$scope',
						 '$controller',
						 function ($rootScope, $scope,
						 		   $controller) {
						     // Box template
						     $scope.baseTemplatePath = '/app/shared/corporateRole/corporateRole.[Template].tpl.html';

						     // Page is dirty
						     $scope.ctxtCtrl = {};
						     $scope.ctxtCtrl.needSaveChanges = false;



						     $controller('BoxTmplController', { $scope: $scope });
						 }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();